import React from 'react';
import {Layout} from 'antd';
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../utils/NHCore";
import css from "./index.css"
const {Content} = Layout;

export default class XyjfcxtjTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('学生缴费信息');
    }

    fmoney = (s, n) => //s:传入的float数字 ，n:希望返回小数点几位
    {
        if (s == undefined) {
            s = 0
        }
        n = n > 0 && n <= 20 ? n : 2;
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        let l = s.split(".")[0].split("").reverse();
        let r = s.split(".")[1];
        let t = "";
        for (let i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
        return t.split("").reverse().join("") + "." + r;
    }

    render() {
        let columns = [
            {
                title: '序号',
                dataIndex: 'row_id',
                width: '50px',
                render: (text, record, index) => <div>{index + 1}</div>
            }, {
                title: '学院名称',
                dataIndex: 'BMMC',
                width: '120px',
                search: 'input',
                searchType:"select"
            }, {
                title: '学生类别',
                dataIndex: 'XSLB',
                width: '120px',
                search: 'input',
                searchType:"select"
            }, {
                title: '录取人数人数',
                dataIndex: 'lqrs',
                width: '100px',
                search: 'input',
                searchType:"input"
            }, {
                title: '报到人数人数',
                dataIndex: 'BDRS',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '全额缴费人数',
                dataIndex: 'QEJF',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '部分缴费人数',
                dataIndex: 'BFJF',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '未缴费人数',
                dataIndex: 'WJF',
                width: '120px',
                search: 'input',
                searchType:"input"
            }, {
                title: '欠费人数人数',
                dataIndex: 'QFRS',
                width: '120px',
                search: 'input',
                searchType:"input"
            }
        ];
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 230}}>
                <div style={{width: '100%', height: '100%',}}>
                    <NHTable ref='nhTable'
                                rowKey={record => record.PKID}
                                sign={"zhxg_yxxt_tjcx_xyjfrstj_queryPage"}
                                columns={columns}
                                rangeFilter={false}
                                >
                        {hasAuth("zhxg_yxgl_tjcx_xsjfxxcx:export") ?
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick}
                                    style={{marginLeft: 10}}>导出</Button> : undefined}
                    </NHTable>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/xsjfcxtj/xyjfcxtjTab.js